var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorksBrowse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#6395EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 43.6667C37.6971 43.6667 43.6667 37.6971 43.6667 30.3333C43.6667 22.9695 37.6971 17 30.3333 17C22.9695 17 17 22.9695 17 30.3333C17 37.6971 22.9695 43.6667 30.3333 43.6667Z",
    stroke: "#EFF7FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47L39.75 39.75",
    stroke: "#EFF7FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksBrowse);
export default __webpack_public_path__ + "static/media/HowItWorksBrowse.95e76a12cc4620c8ca19454ae0b247f7.svg";
export { ForwardRef as ReactComponent };